import ScrollReveal from '@/components/ScrollReveal';
import GoogleLogo from '@/components/GoogleLogo';
import { Quote } from 'lucide-react';
import { REVIEWS } from '@/lib/testimonials';
import { Avatar, Stars } from '@/components/ReviewParts';

export default function TestimonialsSection() {
  return (
    <section className="py-16 md:py-32 bg-secondary/40">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10 lg:px-16">
        <ScrollReveal>
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
            <div>
              <p className="caps-label text-orange mb-4">Testimonials</p>
              <h2 className="font-display font-extrabold text-navy" style={{ fontSize: 'clamp(2rem, 4vw, 3rem)' }}>
                Loved by landlords &amp; agents
              </h2>
            </div>
            <div className="flex items-center gap-4 px-5 py-4 bg-white rounded-2xl border border-navy/10 shadow-sm">
            <GoogleLogo className="w-8 h-8 flex-shrink-0" />
            <div>
              <Stars rating={5} />
              <p className="text-xs text-muted-foreground mt-1">Google Reviews</p>
            </div>
            </div>
          </div>
        </ScrollReveal>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {REVIEWS.map((review, i) => (
            <ScrollReveal key={review.name} delay={(i % 3) * 0.1}>
              <div className="h-full bg-white rounded-2xl border border-navy/10 p-7 flex flex-col">
                <div className="flex items-center justify-between mb-4">
                  <span className="text-xs font-semibold text-navy/60 bg-navy/5 px-3 py-1 rounded-full">{review.source}</span>
                  <Quote className="w-8 h-8 text-orange/15" />
                </div>
                <Stars rating={review.rating} />
                <p className="text-sm text-navy/80 leading-relaxed mt-4 flex-1">"{review.text}"</p>
                <div className="flex items-center gap-3 mt-6 pt-5 border-t border-navy/5">
                  <Avatar initials={review.initials} bg={review.avatarBg} />
                  <div className="min-w-0">
                    <p className="text-sm font-semibold text-navy truncate">{review.name}</p>
                    <p className="text-xs text-muted-foreground truncate">{review.role}</p>
                  </div>
                  <span className="ml-auto text-xs text-muted-foreground flex-shrink-0">{review.date}</span>
                </div>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}